export const environment = {
  production: false,
  auth: {
    url: 'https://api-dev.rsmnet.work/auth/api/v1',
    // url: 'http://localhost:8080/api/v1',
  },
  agent: {
    url: 'https://api-dev.rsmnet.work/agent/api/v1',
    // url: 'http://localhost:8082/api/v1',
  },
  corp: {
    url: 'https://api-dev.rsmnet.work/corp/api/v1',
    // url: 'http://localhost:8083/api/v1',
  },
  mission: {
    url: 'https://api-dev.rsmnet.work/mission/api/v1',
    // url: 'http://localhost:8081/api/v1',
  },
  chat: {
    url: 'https://api-dev.rsmnet.work/agent/api/v1',
    // url: 'http://localhost:8082/api/v1',
  },
  cometchat: {
    appId: '16790884461cb385e',
    region: 'us',
  },
  onesignal: {
    appId: 'ae3126eb-9ed8-4650-812e-a557841a3e08',
  },
  maps: {
    googleApiKey: 'AIzaSyAqfXINdZzTZ8XArPC1TSx8THZdWi8wj2Y',
    usersMapSummaryEnabled: true,
  },
};
